import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { Ethnicity } from "Globals/Models/Ethnicity";

export class EthnicityStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private ethnicity: Ethnicity[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.ethnicity = initialState.ethnicities;
    }

    @MobX.action
    public getEthnicityName(ethnicityId: string | null): string {
        if (ethnicityId == "0" || ethnicityId == null || ethnicityId == "") return "Error";
        let value = this.getSortedByOrdinal.find((value) => ethnicityId === value.id);
        return value ? value.name : "Unknown";
    }
    @MobX.action
    public getRequiresOther(ethnicityId: string | null): boolean {
        if (ethnicityId == "0" || ethnicityId == null || ethnicityId == "") return false;
        let value = this.getSortedByOrdinal.find((value) => ethnicityId === value.id);
        return value ? value.requiresOther : false;
    }

    @MobX.computed
    public get getSortedByOrdinal(): Ethnicity[] {
        return this.ethnicity.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    @MobX.computed
    public get getEthnicityOptions(): KeyValuePair[] {
        let placeholder = {
            key: "Please select",
            value: "placeholder",
        } as KeyValuePair;

        let options = this.getSortedByOrdinal.map((value) => ({ value: value.id, key: value.name })) as KeyValuePair[];

        options.unshift(placeholder);

        return options;
    }
}
